<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body">
          <form #appointmentForm="ngForm" name="appointmentForm">
            <div class="row">
              <div class="col-12">
                <h5 class="header-title heading-color">APPOINTMENT SCHEDULE</h5>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="card m-b-30">
                    <div class="card-body">


                      <form #appointmentForm="ngForm" name="appointmentForm">
                        <div class="row">
                          <div class="col-12">
                            <h6 class="text-center">SEARCH BY PATIENT DETAILS</h6>
                          </div>
                        </div><br>
                        <div class="row">
                          <div class="col-lg-2">

                          </div>



                          <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <input type="text" name="appointment['name']" [(ngModel)]="appointment['name']"
                              placeholder="Patient Name" class="form-control select" />
                          </div>

                          <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <input type="number" name="appointment['contact']" class="form-control select"
                              placeholder="Mobile No" [(ngModel)]="appointment['contact']" />
                          </div>

                          <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <input type="text" name="appointment['city']" [(ngModel)]="appointment['city']"
                              placeholder="Location" class="form-control select" />
                          </div>


                          <div class="col-lg-1"></div>
                        </div><br /><br />






                        <div class="row">
                          <div class="col-lg-3 col-md-3"></div>



                          <div class="col-12">
                            <h6 class="text-center">SEARCH BY DATES</h6>
                          </div>

                          <div class="col-lg-3 col-md-3"></div>

                          <div class="d-flex col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <div class="dp-hidden position-absolute">
                              <div class="input-group">

                                <!-- <input name="datepicker" ngbDatepicker #datepicker="ngbDatepicker"
                                  (dateSelect)="onDateSelection($event)" [matDatepicker]="picker"> -->
                                <input name="datepicker" class="form-control" ngbDatepicker #datepicker="ngbDatepicker"
                                  [autoClose]="'outside'" (dateSelect)="onDateSelection($event, datepicker)"
                                  [displayMonths]="2" [dayTemplate]="t" outsideDays="hidden" tabindex="-1"
                                  style="border:1px solid white !important;" />
                                <ng-template #t let-date let-focused="focused">
                                  <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                                    [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                                    (mouseleave)="hoveredDate = null">
                                    {{ date.day }}
                                  </span>
                                </ng-template>
                              </div>
                            </div>

                            <div class="input-group">
                              <input class="form-control" placeholder="From Date" name="appointment['fromDate']"
                                [value]="formatter.format(fromDate)"
                                (input)="fromDate = validateInput(fromDate, appointment['fromDate'].value)" />

                              <button class="btn btn-outline-secondary button-height calendar rounded-0"
                                (click)="datepicker.toggle()" type="button"><span
                                  class="fa fa-calendar"></span></button>
                            </div>

                          </div>


                          <div class="d-flex col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <div class="input-group">
                              <input class="form-control" placeholder="To Date" name="appointment['toDate']"
                                [value]="formatter.format(toDate)"
                                (input)="toDate = validateInput(toDate, appointment['toDate'].value)" />
                              <button class="btn btn-outline-secondary button-height calendar rounded-0"
                                (click)="datepicker.toggle()" type="button"><span
                                  class="fa fa-calendar"></span></button>
                            </div>
                          </div>


                          <div class="col-lg-3 col-md-3"></div>

                        </div><br><br>


                        <div class="row">
                          <div class="col-12 text-center">
                            <button type="submit" name="find" class="btn btn-primary text-white btn-rounded"
                              (click)="fetchPatients(appointment)">FIND PATIENT</button>&nbsp;&nbsp;
                            <button type="button" name="find" class="btn btn-secondary text-white btn-rounded"
                              (click)="refresh(appointment)">Reset</button>
                          </div>
                        </div>
                      </form>

                      <div *ngIf="isLoading">
                        <appLoader [size]="small" [display]="isLoading" [screen]="container" style="z-index: 1000;">
                        </appLoader>
                      </div>

                      <br><br><br>

                      <div class="row" *ngIf="pdata?.length > 0">

                        <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12" *ngFor="let pat of pdata">

                          <div *ngIf="pat.avatarimg !='img_avatar.png'" style="text-align: center;">
                            <img [src]="pat.ppurl" class="image">
                          </div>

                          <div class="profileImage" style="text-align: center;"
                            *ngIf="pat.avatarimg =='img_avatar.png'">

                            <avatar text={{pat?.name}} hash={{pat?.name}}></avatar>

                          </div>



                          <!-- <div style="text-align: center;">
                            <img [src]="pat?.ppurl" class="image">
                          </div> -->
                          <div class="user_card">
                            <div class="row">
                              <div class="col-5">
                                <label class="label1">Name:</label>
                              </div>
                              <div class="col-7">
                                <label class="label2">{{pat?.first_name}} {{pat?.last_name}}</label>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-5">
                                <label class="label1">Patient ID:</label>
                              </div>
                              <div class="col-7">
                                <label class="label2">{{pat?.pid}}</label>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-5">
                                <label class="label1">DOB:</label>
                              </div>
                              <div class="col-7">
                                <label class="label2">{{pat?.dob | date:'dd-MM-yyyy'}}</label>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-5">
                                <label class="label1">Gender:</label>
                              </div>
                              <div class="col-7">
                                <label class="label2">{{pat?.gender}}</label>
                              </div>
                            </div>



                            <div class="row">
                              <div class="col-5">
                                <label class="label1">Address:</label>
                              </div>
                              <div class="col-7">
                                <label class="label2">{{pat?.city_n}}</label>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-5">
                                <label class="label1">Contact:</label>
                              </div>
                              <div class="col-7">

                                <label class="label2">{{pat?.contact_no}}</label>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12 button">
                            <button type="button" class="btn btn-primary form-control text-white" id="{{pat?.pid}}"
                              (click)="patientSelection(pat['pid']); getToBottom();">{{selectButtonName}}</button>
                          </div><br>
                        </div>
                      </div>
                    </div>
                  </div><br><br><br><br><br><br><br><br><br><br><br><br>
                  <div class="row" *ngIf="patientIdBasedData">
                    <div class="col-lg-12">
                      <div class="card m-b-30">
                        <div class="card-body">
                          <div class="row">
                            <div class="col-lg-4 my-auto">


                              <!-- <div style="text-align: center;"> -->
                              <div *ngIf="patientIdBasedData.avatarimg !='img_avatar.png'" style="text-align: center;">
                                <img [src]="patientIdBasedData.ppurl" class="image">
                              </div>
                              <div class="profileImage" *ngIf="patientIdBasedData.avatarimg =='img_avatar.png'"
                                style="text-align: center;">
                                <avatar text={{patientIdBasedData?.name}} hash={{patientIdBasedData?.name}}></avatar>
                              </div>
                              <!-- </div> -->



                              <!-- <div style="text-align: center;">
                                <img [src]="patientIdBasedData?.ppurl" class="image">
                              </div> -->


                              <div class="user_card">
                                <div class="row">
                                  <div class="col-5">
                                    <label class="label1">Name:</label>
                                  </div>
                                  <div class="col-7">
                                    <label class="label2">{{patientIdBasedData?.first_name}}
                                      {{patientIdBasedData?.last_name}}
                                    </label>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-5">
                                    <label class="label1">Patient ID:</label>
                                  </div>
                                  <div class="col-7">
                                    <label class="label2">{{patientIdBasedData?.pid}}</label>
                                  </div>
                                </div>

                                <div class="row">
                                  <div class="col-5">
                                    <label class="label1">DOB:</label>
                                  </div>
                                  <div class="col-7">
                                    <label class="label2">{{patientIdBasedData?.dob | date:'dd-MM-yyyy'}}</label>
                                  </div>
                                </div>

                                <div class="row">
                                  <div class="col-5">
                                    <label class="label1">Gender:</label>
                                  </div>
                                  <div class="col-7">
                                    <label class="label2">{{patientIdBasedData?.gender}}</label>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-5">
                                    <label class="label1">Address:</label>
                                  </div>
                                  <div class="col-7">
                                    <label class="label2">{{patientIdBasedData?.city_n}}</label>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-5">
                                    <label class="label1">Contact:</label>
                                  </div>
                                  <div class="col-7">

                                    <label class="label2">{{patientIdBasedData?.contact_no}}</label>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-12 bg-primary text-center text-white py-2">
                                SELECTED
                              </div>

                              <div class="col-md-12 mt-3">
                                <label>Reason for visit</label>
                                <form [formGroup]="forms['reasonForm']">
                                  <textarea name="reasons" class="form-control" formControlName="reasons" rows="4"
                                    value="{{reason}}"></textarea>
                                </form>
                              </div>
                            </div>



                            <div class="col-md-8">
                              <div class="mb-3" style="text-align: center;">
                                <h6>SCHEDULE AN APPOINTMENT</h6> <br>
                                <!-- Book an appointment for Inperson and Online Appointment (NEED FOR FURTHER DEVELOPMENT -->
                                <div class="form-check form-check-inline">
                                  <input class="form-check-input" type="radio" formControlName="scheduleOptions"
                                    (click)="signUpUser(0)" name="scheduleOptions" id="inlineRadio1" checked="true"
                                    [checked]="!isChecked" />
                                  <label class="form-check-label font-size-15 font-weight-500"
                                    for="inlineRadio1">Inperson</label>
                                </div>
                                <div class="form-check form-check-inline ml-5">
                                  <input class="form-check-input" type="radio" (click)="signUpUser(1)"
                                    formControlName="scheduleOptions" name="scheduleOptions" id="inlineRadio2"
                                    [checked]="isChecked" />
                                  <label class="form-check-label font-size-15 font-weight-500"
                                    for="inlineRadio2">Online</label>
                                </div>
                              </div>
                              <form [formGroup]="scheduleAppointmentForm">
                                <div class="row" style="margin-top: 18px;">
                                  <div class="col-md-12">
                                    <label for="name" class="text-change font-weight-500">Physician<span
                                        class="text-danger">*</span></label>
                                    <select name="model" formControlName="drid" class="form-control select"
                                      (change)=" getDefaultWorkingHours($event.target.value)">
                                      <option *ngFor="let p of physician" [value]="p?.u_id">
                                        {{p?.fullname}}
                                      </option>
                                    </select>
                                    <div *ngIf="scheduleAppointmentForm.get('drid').hasError('required')"
                                      class="invalid-feedback">
                                      Physician name is required
                                    </div>
                                  </div>
                                </div><br>
                                <p>Appointment Date and Time:</p>
                                <div class="row mb-3">
                                  <div class="col-md-6 col-lg-5">
                                    <div class="input-group m-t-10">
                                      <div class="d-flex">
                                        <input class="form-control" placeholder="Start Date(DD/MM/YYYY)"
                                          name="startDate" formControlName="startDate" ngbDatepicker #sd="ngbDatepicker"
                                          (dateSelect)="dateTimeChangeEvent($event)" data-date-inline-picker="false"
                                          id="startDate" [minDate]="currentDate" [markDisabled]="disableWeekends" />
                                        <div>
                                          <button class="btn btn-outline-secondary calendar rounded-0"
                                            (click)="sd.toggle()" type="button" style="line-height: 2.5;"
                                            id="startDateButton">
                                            <span class="fa fa-calendar"></span>
                                          </button>
                                        </div>
                                      </div>
                                      <div *ngIf="scheduleAppointmentForm.get('startDate').hasError('required')"
                                        class="invalid-feedback"> Start Date is required
                                      </div>
                                      <div
                                        *ngIf="scheduleAppointmentForm.controls['startDate'].touched && scheduleAppointmentForm.get('startDate').hasError('ngbDate')"
                                        class="invalid-feedback"> Start Date is invalid
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6 col-lg-5" *ngIf="scheduleOptions != 1">
                                    <div class="input-group m-t-10">
                                      <div class="d-flex">
                                        <input class="form-control" placeholder="End Date(DD/MM/YYYY)" name="endDate"
                                          formControlName="endDate" ngbDatepicker #ed="ngbDatepicker"
                                          [minDate]="scheduleAppointmentForm.value.startDate" [markDisabled]="disableWeekends"
                                          data-date-inline-picker="false" id="endDate" />
                                        <div>
                                          <button class="btn btn-outline-secondary calendar rounded-0"
                                            (click)="ed.toggle()" type="button" style="line-height: 2.5;"
                                            id="endDateButton">
                                            <span class="fa fa-calendar"></span>
                                          </button>
                                        </div>
                                      </div>
                                      <div *ngIf="scheduleAppointmentForm.get('endDate').hasError('ngbDate')"
                                        class="invalid-feedback"> End Date is invalid
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6 col-lg-5">
                                    <label>Start Time</label>
                                    <ngb-timepicker formControlName="startTime" meridian=true
                                      (ngModelChange)="dateTimeChangeEvent($event)">
                                    </ngb-timepicker>
                                    <div *ngIf="scheduleAppointmentForm.get('startTime').hasError('required')"
                                      class="invalid-feedback"> Start Time is required
                                    </div>
                                    <div *ngIf="scheduleAppointmentForm.get('startTime').hasError('invalidStartTime')"
                                      class="invalid-feedback"> Start Time is invalid
                                    </div>
                                  </div>
                                  <div class="col-md-6 col-lg-5">
                                    <label>End Time</label>
                                    <ngb-timepicker formControlName="endTime" meridian=true
                                      (ngModelChange)="validateEndTime($event)"></ngb-timepicker>
                                    <div *ngIf="scheduleAppointmentForm.get('endTime').hasError('invalidEndTime')"
                                      class="invalid-feedback"> End-Time should be greater than Start-Time
                                    </div>
                                  </div>

                                  <div class="col-md-6 col-lg-4 col-xl-2 my-auto pt-5 pl-0 ">
                                    <button type="button" class="btn btn-primary border btn-rounded px-3"
                                      [disabled]="!scheduleAppointmentForm.value.drid"
                                      (click)="openCalendarMOdal()">View
                                      calendar</button>
                                  </div>
                                </div>
                                <!-- <div class="form-check d-flex mt-3">
                                  <input type="checkbox" class="form-check-input" id="termsnCondition"
                                    [checked]="termsAndCondition" (change)="tacChecked($event)" required>
                                  <label class="form-check-label ml-2" for="exampleCheck1">I accept
                                    <a href="{{termsUrl}}" class="text-primary" target="_blank">terms and
                                      condition</a></label>
                                </div> -->
                              </form>


                            </div>

                            <div class="col-md-3">
                            </div>
                          </div><br><br>
                          <div class="row">
                            <div class="col-md-12 text-center">
                              <button type="button" class="btn btn-primary border text-white btn-rounded"
                                [disabled]="scheduleAppointmentForm.invalid || termsAndCondition == false"
                                (click)="addSchedule(scheduleAppointmentForm.value);">SCHEDULE
                                APPOINTMENT</button>&nbsp;&nbsp;&nbsp;
                              <button type="reset" (click)="getToTop(); resetForm(scheduleAppointmentForm)()"
                                class="btn btn-outline-secondary btn-rounded">CANCEL</button>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--end container-->